var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAustraliaLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 111,
    viewBox: "0 0 140 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1889 63.5293C23.2119 63.8793 23.2119 64.1123 23.1889 64.2293C23.2569 64.0253 23.3759 63.8793 23.5799 63.7333C23.4439 63.6463 23.3079 63.5883 23.1719 63.5293",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6906 15.1478H75.5406L75.0406 16.6358H72.8906L75.9406 8.21179H78.3206L81.3606 16.6358H79.1906L78.6906 15.1478ZM78.1606 13.5638L77.1206 10.4798L76.0806 13.5638H78.1606ZM84.3106 8.21179V13.2518C84.3106 13.7558 84.4306 14.1438 84.6806 14.4158C84.9306 14.6878 85.2906 14.8238 85.7706 14.8238C86.2506 14.8238 86.6206 14.6878 86.8706 14.4158C87.1306 14.1438 87.2606 13.7558 87.2606 13.2518V8.21179H89.3106V13.2398C89.3106 13.9918 89.1506 14.6278 88.8306 15.1478C88.5106 15.6678 88.0806 16.0598 87.5306 16.3238C87.0006 16.5878 86.4006 16.7198 85.7306 16.7198C85.0706 16.7198 84.4706 16.5918 83.9506 16.3358C83.4306 16.0718 83.0106 15.6798 82.7106 15.1598C82.4106 14.6318 82.2506 13.9918 82.2506 13.2398V8.21179H84.3106ZM93.8006 16.7198C93.1806 16.7198 92.6306 16.6198 92.1406 16.4198C91.6606 16.2198 91.2606 15.9238 90.9706 15.5318C90.6806 15.1398 90.5306 14.6678 90.5106 14.1158H92.7006C92.7306 14.4278 92.8406 14.6678 93.0206 14.8358C93.2006 14.9958 93.4406 15.0758 93.7406 15.0758C94.0406 15.0758 94.2806 15.0078 94.4606 14.8718C94.6406 14.7278 94.7206 14.5318 94.7206 14.2838C94.7206 14.0758 94.6506 13.9038 94.5106 13.7678C94.3706 13.6318 94.2006 13.5198 93.9906 13.4318C93.7906 13.3438 93.5006 13.2438 93.1306 13.1318C92.5806 12.9638 92.1406 12.7958 91.8006 12.6278C91.4506 12.4598 91.1606 12.2118 90.9106 11.8838C90.6606 11.5558 90.5406 11.1278 90.5406 10.5998C90.5406 9.81579 90.8206 9.20379 91.3906 8.76379C91.9606 8.31579 92.7006 8.0918 93.6106 8.0918C94.5406 8.0918 95.2806 8.31579 95.8506 8.76379C96.4206 9.20379 96.7206 9.81979 96.7606 10.6118H94.5406C94.5306 10.3398 94.4306 10.1278 94.2406 9.9758C94.0606 9.8158 93.8206 9.73578 93.5406 9.73578C93.2906 9.73578 93.0906 9.80379 92.9406 9.93979C92.7806 10.0678 92.7106 10.2558 92.7106 10.5038C92.7106 10.7758 92.8406 10.9878 93.0906 11.1398C93.3506 11.2918 93.7506 11.4558 94.2906 11.6318C94.8406 11.8158 95.2806 11.9918 95.6106 12.1598C95.9606 12.3278 96.2506 12.5718 96.5006 12.8918C96.7506 13.2118 96.8706 13.6238 96.8706 14.1278C96.8706 14.6078 96.7506 15.0438 96.5006 15.4358C96.2606 15.8278 95.9106 16.1398 95.4406 16.3718C94.9806 16.6038 94.4306 16.7198 93.8006 16.7198ZM104.191 8.21179V9.8558H101.961V16.6358H99.9106V9.8558H97.6807V8.21179H104.191ZM109.521 16.6358L107.771 13.4558H107.281V16.6358H105.221V8.21179H108.671C109.331 8.21179 109.901 8.32778 110.361 8.55978C110.831 8.79178 111.181 9.11181 111.421 9.51981C111.651 9.91981 111.761 10.3678 111.761 10.8638C111.761 11.4238 111.601 11.9238 111.281 12.3638C110.971 12.8038 110.511 13.1158 109.891 13.2998L111.841 16.6358H109.521ZM107.281 12.0038H108.551C108.921 12.0038 109.201 11.9118 109.391 11.7278C109.581 11.5438 109.681 11.2838 109.681 10.9478C109.681 10.6278 109.581 10.3758 109.391 10.1918C109.201 10.0078 108.921 9.9158 108.551 9.9158H107.281V12.0038ZM118.301 15.1478H115.151L114.651 16.6358H112.501L115.551 8.21179H117.921L120.971 16.6358H118.801L118.301 15.1478ZM117.771 13.5638L116.721 10.4798L115.691 13.5638H117.771ZM123.951 15.0518H126.641V16.6358H121.901V8.21179H123.951V15.0518ZM129.671 8.21179V16.6358H127.621V8.21179H129.671ZM136.401 15.1478H133.261L132.751 16.6358H130.611L133.651 8.21179H136.031L139.081 16.6358H136.911L136.401 15.1478ZM135.871 13.5638L134.831 10.4798L133.801 13.5638H135.871Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5311 0.423828C12.1331 0.423828 0.453125 11.7388 0.453125 25.6878C0.453125 33.5308 4.57815 40.0858 9.93915 45.1748C22.7621 57.3578 23.8891 48.3928 26.5311 111C29.1731 48.3928 30.2851 57.3578 43.1241 45.1748C48.4851 40.0708 52.6091 33.5308 52.6091 25.6878C52.6091 11.7388 40.9301 0.423828 26.5311 0.423828Z",
    fill: "url(#paint0_linear_262_461)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M26.5315 47.4195C38.6645 47.4195 48.5005 37.8905 48.5005 26.1365C48.5005 14.3815 38.6645 4.85352 26.5315 4.85352C14.3985 4.85352 4.5625 14.3815 4.5625 26.1365C4.5625 37.8905 14.3985 47.4195 26.5315 47.4195Z",
    fill: "url(#paint1_linear_262_461)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5316 44.3959C36.9406 44.3959 45.3796 36.2209 45.3796 26.1369C45.3796 16.0519 36.9406 7.87695 26.5316 7.87695C16.1216 7.87695 7.68359 16.0519 7.68359 26.1369C7.68359 36.2209 16.1216 44.3959 26.5316 44.3959Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_262_461",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 19,
    width: 19,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19H17V33H36V19Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_262_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 19H36V33H17V19Z",
    fill: "#00008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.113 19L21.735 21.64L25.342 19H26.5V19.904L22.938 22.515L26.5 25.11V26H25.312L21.75 23.39L18.202 26H17V25.125L20.548 22.529L17 19.933V19H18.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.294 23.098L26.5 25.417V26L22.477 23.098H23.294ZM20.562 23.39L20.652 23.9L17.802 26H17L20.562 23.39ZM26.5 19V19.044L22.804 21.785L22.834 21.144L25.758 19H26.5ZM17 19L20.548 21.567H19.657L17 19.613V19Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.577 19V26H22.952V19H20.577ZM17 21.333V23.667H26.5V21.333H17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21.815V23.215H26.5V21.815H17ZM21.052 19V26H22.477V19H21.052Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6437 30.5704L32.0347 30.6454L32.1007 31.2434L31.6607 30.8234L31.2247 31.2464L31.2837 30.6484L30.6757 30.5784L31.1887 30.2524L30.8657 29.7414L31.4477 29.9314L31.6517 29.3624L31.8627 29.9284L32.4417 29.7324L32.1237 30.2464L32.6437 30.5704ZM32.5337 27.1514L32.6137 26.7724L32.3227 26.5104L32.7147 26.4664L32.8777 26.1134L33.0417 26.4664L33.4337 26.5104L33.1427 26.7724L33.2227 27.1514L32.8777 26.9594L32.5337 27.1514ZM29.4437 25.4014L28.8407 25.4654L28.8937 26.0574L28.4667 25.6354L28.0277 26.0464L28.0987 25.4544L27.4987 25.3754L28.0127 25.0604L27.7007 24.5504L28.2737 24.7484L28.4877 24.1914L28.6867 24.7544L29.2627 24.5704L28.9387 25.0754L29.4467 25.4014H29.4437ZM35.4937 24.4454L34.8727 24.5234L34.9417 25.1334L34.4927 24.7044L34.0477 25.1364L34.1097 24.5234L33.4897 24.4534L34.0147 24.1184L33.6857 23.5964L34.2797 23.7914L34.4877 23.2144L34.7007 23.7914L35.2917 23.5904L34.9647 24.1154L35.4937 24.4454ZM32.6407 22.0094L32.0257 22.0764L32.0827 22.6834L31.6457 22.2514L31.1977 22.6714L31.2687 22.0674L30.6547 21.9864L31.1797 21.6654L30.8627 21.1434L31.4477 21.3444L31.6637 20.7754L31.8657 21.3504L32.4537 21.1604L32.1237 21.6744L32.6407 22.0094ZM23.9447 30.2494L22.5857 30.4064L22.7217 31.7454L21.7487 30.8004L20.7687 31.7394L20.9137 30.4004L19.5547 30.2314L20.7097 29.5084L19.9967 28.3594L21.2907 28.7964L21.7597 27.5304L22.2207 28.7994L23.5177 28.3704L22.7967 29.5144L23.9477 30.2464L23.9447 30.2494Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_262_461",
    x1: -6.91587,
    y1: 45.2348,
    x2: 42.5841,
    y2: 60.8548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D22C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BA1916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#901916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#851916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_262_461",
    x1: 10.9895,
    y1: 11.0945,
    x2: 41.0735,
    y2: 42.1465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FF765F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF765F",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF765F",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF765F",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF765F",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FF765F",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF765F",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF765F",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF765F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaLocation);
export default __webpack_public_path__ + "static/media/Australia_location.56b247b10ae48425c2d0bc8dabf9f990.svg";
export { ForwardRef as ReactComponent };